import aiConfigTranslations from './aiConfig';
import aiUsageTranslations from './ai-usage';
import accountingTranslations from './accounting';
import authTranslations from './auth';
import cashToCloseTranslations from './cash-to-close';
import closingDisclosure from './closing-disclosure';
import chargesTranslations from './charges';
import closing from './closing';
import commonTranslations from './common';
import contactsTranslations from './contact';
import datesAndConfigurationTranslations from './dates-and-config';
import dialogsTranslations from './dialogs';
import disclosureTranslations from './disclosure';
import documentsTranslations from './documents';
import earnestAndCommissionsTranslations from './earnest-and-commissions';
import inferenceTranslations from './inference';
import lenderTranslations from './lender';
import loanTranslations from './loan';
import loanDisclosuresTranslations from './loan-disclosures';
import menuTranslations from './menu';
import notifications from './notifications';
import onboardingTranslations from './onboarding';
import ordersTranslations from './orders';
import ordersPropertiesTranslations from './orders-properties';
import partiesTranslations from './parties';
import paymentsTranslations from './payments';
import payoffsTranslations from './payoffs';
import revenueTranslations from './revenue';
import policyInfoAndRatesTranslations from './policy-info-and-rates';
import projectedPaymentsTranslations from './projected-payments';
import properties from './properties';
import questionsAndAnswers from './questions-and-answers';
import rolesTranslations from './roles';
import ronTranslations from './ron';
import seller from './seller';
import settlementTranslations from './settlement';
import taxesAndFeesTranslations from './taxes-and-fees';
import taxesAndProrationsTranslations from './taxes-and-prorations';
import teamAndReporting from './team-and-reporting';
import usersTranslations from './users';
import validationsTranslations from './validations';
import disbursmentsTranslations from './disbursments';
import emailTemplates from './emailTemplates';
import messages from './messages';
import notes from './notes';
import systemValuesTranslations from './system-values';
import importsTranslations from './imports';

export default {
  en: {
    auth: authTranslations.en,
    cashToClose: cashToCloseTranslations.en,
    closingDisclosure: closingDisclosure.en,
    charges: chargesTranslations.en,
    common: commonTranslations.en,
    dialogs: dialogsTranslations.en,
    documents: documentsTranslations.en,
    earnestAndCommissions: earnestAndCommissionsTranslations.en,
    emailTemplates: emailTemplates.en,
    inference: inferenceTranslations.en,
    lender: lenderTranslations.en,
    loan: loanTranslations.en,
    loanDisclosures: loanDisclosuresTranslations.en,
    onboarding: onboardingTranslations.en,
    orders: ordersTranslations.en,
    ordersProperties: ordersPropertiesTranslations.en,
    parties: partiesTranslations.en,
    payments: paymentsTranslations.en,
    payoffs: payoffsTranslations.en,
    revenue: revenueTranslations.en,
    policyInfoAndRates: policyInfoAndRatesTranslations.en,
    taxesAndProrations: taxesAndProrationsTranslations.en,
    users: usersTranslations.en,
    validations: validationsTranslations.en,
    contact: contactsTranslations.en,
    taxesAndFees: taxesAndFeesTranslations.en,
    disclosure: disclosureTranslations.en,
    projectedPayments: projectedPaymentsTranslations.en,
    datesAndConfig: datesAndConfigurationTranslations.en,
    teamAndReporting: teamAndReporting.en,
    ron: ronTranslations.en,
    closing: closing.en,
    seller: seller.en,
    properties: properties.en,
    aiConfig: aiConfigTranslations.en,
    aiUsage: aiUsageTranslations.en,
    accounting: accountingTranslations.en,
    questionsAndAnswers: questionsAndAnswers.en,
    roles: rolesTranslations.en,
    menu: menuTranslations.en,
    notifications: notifications.en,
    disbursments: disbursmentsTranslations.en,
    messages: messages.en,
    notes: notes.en,
    settlement: settlementTranslations.en,
    systemValues: systemValuesTranslations.en,
    imports: importsTranslations.en,
  },
  es: {
    auth: authTranslations.es,
    cashToClose: cashToCloseTranslations.es,
    closingDisclosure: closingDisclosure.es,
    charges: chargesTranslations.es,
    common: commonTranslations.es,
    dialogs: dialogsTranslations.es,
    documents: documentsTranslations.es,
    earnestAndCommissions: earnestAndCommissionsTranslations.es,
    emailTemplates: emailTemplates.es,
    inference: inferenceTranslations.es,
    lender: lenderTranslations.es,
    loan: loanTranslations.es,
    loanDisclosures: loanDisclosuresTranslations.es,
    onboarding: onboardingTranslations.es,
    orders: ordersTranslations.es,
    ordersProperties: ordersPropertiesTranslations.es,
    parties: partiesTranslations.es,
    payments: paymentsTranslations.es,
    payoffs: payoffsTranslations.es,
    revenue: revenueTranslations.es,
    policyInfoAndRates: policyInfoAndRatesTranslations.es,
    taxesAndProrations: taxesAndProrationsTranslations.es,
    users: usersTranslations.es,
    validations: validationsTranslations.es,
    contact: contactsTranslations.es,
    taxesAndFees: taxesAndFeesTranslations.es,
    disclosure: disclosureTranslations.es,
    projectedPayments: projectedPaymentsTranslations.es,
    datesAndConfig: datesAndConfigurationTranslations.es,
    teamAndReporting: teamAndReporting.es,
    ron: ronTranslations.es,
    closing: closing.es,
    seller: seller.es,
    properties: properties.es,
    aiConfig: aiConfigTranslations.es,
    aiUsage: aiUsageTranslations.es,
    accounting: accountingTranslations.es,
    questionsAndAnswers: questionsAndAnswers.es,
    roles: rolesTranslations.es,
    menu: menuTranslations.es,
    notifications: notifications.es,
    disbursments: disbursmentsTranslations.es,
    messages: messages.es,
    notes: notes.es,
    settlement: settlementTranslations.es,
    systemValues: systemValuesTranslations.es,
    imports: importsTranslations.es,
  },
};
